// extracted by mini-css-extract-plugin
export default {"logoWrapper":"logo-wrapper--BQU8HFsRkEviBFfZAAK2","logo":"logo--WkgVPPAt1XhDpl5tHzY1","lightTheme":"light-theme--Xolji7v8QYvhFyKUDQvU","darkTheme":"dark-theme--z2VwkVwI5bmSKVJNA4jT"};